import cleanString from './cleanString'
import isGTIN from './isGTIN'
import { parseProductSpecification } from './parseProductSpecification'

export const createProductSchema = (shopifyProduct, contentfulData, selectedVariant = null) => {
  let stockStatus = ''
  let barcode = ''
  let sku = ''
  let image = ''
  let additionalProperty = ''
  let title = ''
  let price = ''

  const currentVariant = selectedVariant ?? shopifyProduct.variants?.at(0)

  if (shopifyProduct?.tracksInventory === false) {
    stockStatus = 'InStock'
  } else if (shopifyProduct.totalInventory === 0) {
    stockStatus = 'OutOfStock'
  } else {
    stockStatus = currentVariant?.availableForSale ? 'InStock' : 'OutOfStock'
  }

  if (!shopifyProduct.hasOnlyDefaultVariant) {
    title = `${shopifyProduct.title} - ${currentVariant?.title}`
  } else {
    title = `${shopifyProduct.title}`
  }

  const productSpecification =
    contentfulData &&
    contentfulData?.productSpecification &&
    contentfulData?.productSpecification?.productSpecification
      ? contentfulData?.productSpecification.productSpecification
      : null

  const productSpecificationParsed = parseProductSpecification(productSpecification)

  const futureDate = new Date()
  futureDate.setFullYear(futureDate.getFullYear() + 10)

  if (currentVariant?.barcode && isGTIN(currentVariant?.barcode)) {
    barcode = `"gtin13": "${currentVariant?.barcode}",`
  }

  if (currentVariant?.sku) {
    sku = `"sku": "${currentVariant?.sku}",`
  }

  if (currentVariant?.image) {
    image =
    `"image": {
      "@type": "ImageObject",
      "url": "${currentVariant?.image.originalSrc}", 
      "caption":"${currentVariant?.image?.altText || "No product image"}"
    },`
  } else if (shopifyProduct.featuredImage) {
    image =
  `"image": {
      "@type": "ImageObject",
      "url": "${shopifyProduct.featuredImage.originalSrc}", 
      "caption":"${shopifyProduct.featuredImage?.altText || "No product image"}"
    },`
  } else {
    image =
  `"image": {
      "@type": "ImageObject",
      "url": "https://placehold.co/400x400?text=No%20Image", 
      "caption":"No product image"
    },`
  }

  if (currentVariant?.compareAtPrice) {
    price = parseFloat(currentVariant?.compareAtPrice).toFixed(1)
  } else {
    price = parseFloat(currentVariant?.price).toFixed(1)
  }

  if (productSpecificationParsed && productSpecificationParsed.length) {
    additionalProperty = `"additionalProperty": [
      ${productSpecificationParsed
        ?.map(
          (specification) => `{
           "@type": "PropertyValue",
            "name": "${cleanString(specification.name)}",
            "value": "${cleanString(specification.value)}"
        }`
        )
        .join(',')}
    ],`
  }

  return `{
  "@context": "https://schema.org/", 
  "@type": "Product", 
  "name": "${cleanString(title)}",
  ${image}
  "brand": {
    "@type": "Brand",
    "name": "${shopifyProduct.vendor}"
  },
  ${barcode}
  ${sku}
  ${additionalProperty}
  "offers": {
    "@type": "Offer",
    "url": "${process.env.GATSBY_HELIGUY_DOMAIN}/products/${shopifyProduct.handle}${selectedVariant ? `?variant=${selectedVariant?.shopifyId.replace('gid://shopify/ProductVariant/', '')}` : ''}",
    "priceCurrency": "GBP",
    "price": "${price}",
    "availability": "https://schema.org/${stockStatus}",
    "priceValidUntil": "${futureDate.toISOString()}",
    "itemCondition": "https://schema.org/NewCondition"
  }
}`
}
